import React from 'react';
import './UrgencyBanner.css';

// Configuration session - à modifier pour chaque session
const SESSION_NAME = "Mars 2026";
const TOTAL_PLACES = 10;
const PLACES_PRISES = 4;
const PLACES_RESTANTES = TOTAL_PLACES - PLACES_PRISES;

const UrgencyBanner = () => {
  return (
    <div className="urgency-banner">
      <div className="urgency-banner-content">
        <span className="urgency-dot"></span>
        <span className="urgency-text">
          Session {SESSION_NAME} — <strong>{PLACES_RESTANTES} places restantes</strong> sur {TOTAL_PLACES}
        </span>
      </div>
    </div>
  );
};

// Export des constantes pour les autres composants
export { SESSION_NAME, TOTAL_PLACES, PLACES_PRISES, PLACES_RESTANTES };
export default UrgencyBanner;
